export default __webpack_public_path__ + "static/media/others.02c791d5.svg";